import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  expand: {
    id: 'app.shared.iconLabels.expand',
    defaultMessage: 'Show more',
    description: 'Reveal additional content',
  },
  collapse: {
    id: 'app.shared.iconLabels.collapse',
    defaultMessage: 'Show less',
    description: 'Hide expanded content',
  },
  clearFilters: {
    id: 'app.shared.iconLabels.clearFilters',
    defaultMessage: 'Clear filters',
    description: 'Remove all selected filters',
  },
  searchJobs: {
    id: 'app.shared.iconLabels.searchJobs',
    defaultMessage: 'Search by Location or Job',
    description: 'Find openings by their location or job',
  },
  insertEmoji: {
    id: 'app.shared.iconLabels.insertEmoji',
    defaultMessage: 'Insert emoji',
    description: 'Insert an emoji into a message',
  },
  manageRoster: {
    id: 'app.shared.iconLabels.manageRoster',
    defaultMessage: 'Manage Roster',
    description: 'Manage the applicants attending an event',
  },
  attachedFile: {
    id: 'app.shared.iconLabels.attachedFile',
    defaultMessage: 'Attached file',
    description: 'A file attached to a message or response',
  },
});
